//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import AdminModal from "./AdminModal";
import ClientRequestInfo from "./ClientRequestInfo";
import RequestPoolComponent from "./RequestPoolComponent";
import { IOldRequestStore } from "../stores";
import axios from "axios";

const BodyContent: React.FC<{ store: IOldRequestStore }> = observer(
  ({ store }) =>
    store.loading === true ? (
      <div className="loader main-loader" />
    ) : (
      <div className="row">
        <div className="col-12">
          <div className="tutor-pool--list">
            {store.requestPool.length > 0 ? (
              store.requestPool.map((pool) => (
                <RequestPoolComponent
                  store={store}
                  poolId={pool.pool_id}
                  tutorName={pool.full_name}
                  tutorEmail={pool.email}
                  tutorPhoneNo={pool.phone_no}
                  tutorAddress={pool.address}
                  cost={pool.cost}
                  defaultSubject={pool.default_subject}
                  matchedSubjects={pool.matched_subjects}
                  approved={pool.approved}
                  teachesAll={pool.teaches_all}
                  toggleTutorApprovalFunc={(
                    poolId: any,
                    approval: any,
                    component: any,
                  ) =>
                    store.handleToggleTutorApproval(poolId, approval, component)
                  }
                  updateMsg={store.updateMsg}
                  updateTutorPrice={store.updateTutorPrice}
                  changeDefaultSubject={store.changeDefaultSubject}
                />
              ))
            ) : (
              <h1 style={{ margin: "0px", padding: "16px" }}>
                This request has no tutors
              </h1>
            )}
          </div>
        </div>
      </div>
    ),
);

export const ClientRequestModal: React.FC<{ store: IOldRequestStore }> =
  observer(({ store }) => {
    const [newConversion, setNewConversion] = useState<number | null>(null);
    async function conversionDisplay(budget) {
      try {
        const response = await axios.post('https://dev-django.tuteria.com/api/get-currency-rate/', { symbol: store.selectCurrency });
        if (response.status === 200) {
          console.log("DATA", response.data);
          let exchangeRate = response.data.exchangeRate;
          const convertedBudgetNumber = (parseInt(budget) * exchangeRate).toFixed(2);
          console.log("convertedBudgetNumber", convertedBudgetNumber)
          if (!isNaN(convertedBudgetNumber)) {
            setNewConversion(convertedBudgetNumber);
          } else {
            console.error("Invalid converted budget:", convertedBudgetNumber);
          }
        } else {
          console.log("Exchange Rate was not converted")
        }
      } catch (error) {
        console.error('Error fetching currency rate:', error);
        throw error;
      }
    }
    function handleSelectCurrency(event) {
      event.preventDefault();
      if (event.target.value) {
        store.setState({ selectCurrency: event.target.value });
        store.updateCurrency(event.target.value);
        conversionDisplay(store.totalBudget)
      }
    }
    function handleUpdateSplitType(event) {
      event.preventDefault();
      if (event.target.value) {
        store.updateSplitCount(event.target.value);
      }
    }
    function handleUpdateBudget(event) {
      event.preventDefault();
      store.setState({ typing: false });
      if (event.target.budget.value < 0) {
        store.setState({
          typing: true,
          message: {
            status: true,
            text: "Enter a positive value",
            error: true,
          },
        });
      } else if (event.target.budget.value === store.totalBudget) {
        store.setState({
          typing: true,
          message: {
            status: true,
            text: "Modify current client budget",
            error: true,
          },
        });
      } else {
        store.updateBudget(event.target.budget.value);
        if (["$", "£", "C$"].includes(store.selectCurrency)) {
          conversionDisplay(event.target.budget.value)
        } else return;
      }
    }
    function handleRefresh(event) {
      event.preventDefault();
      store.resetState();
      store.fetchTutors();
    }
    function toggleUpdateBtn2(value) {
      store.setState({ typing: value });
    }
    React.useEffect(() => {
      store.fetchTutors();
      return () => {
        store.resetState();
      };
    }, []);
    return (
      <AdminModal
        modalId="clientRequestModal"
        headerContent={
          <ClientRequestInfo
            onSelectCurrency={handleSelectCurrency}
            newConversion={newConversion}
            updateBudget={handleUpdateBudget}
            toggleUpdateBtn2={toggleUpdateBtn2}
            typing={store.typing}
            updateSplitType={handleUpdateSplitType}
            requestSubjects={store.instance.requestSubjects}
            totalBudget={store.totalBudget}
            convertedTotalBudget={store.convertedTotalBudget}
            selectCurrency={store.selectCurrency}
            hourlyBudget={store.hourlyBudget}
            splitCount={store.split_count}
            teachAllSubjects={!store.teachAllSubjects}
          />
        }
        bodyContent={<BodyContent store={store} />}
        message={store.message}
        modalTitle={
          "Request Details of " +
          store.instance.clientName +
          "(" +
          store.instance.clientEmail +
          ")"
        }
        handleRefresh={handleRefresh}
        footerBtn1={() => (
          <a
            href={store.instance.requestUrl}
            target="_blank"
            className="btn btn-secondary btn-sm"
            style={{ marginRight: "10px" }}
            title="view the page the client would see"
          >
            View Client Page
          </a>
        )}
        footerBtn2={() => (
          <button
            className="btn btn-primary btn-sm"
            type="submit"
            disabled={
              store.sending ||
              // store.sent ||
              store.requestPool.length === 0 ||
              !store.isOneActive
            }
            title={
              !store.isOneActive
                ? "at least one tutor must be approved or approved tutors must have at least one active subject"
                : "click to add approved tutors to client pool"
            }
            onClick={store.sendProfileToClient}
          >
            {store.sending ? "Adding..." : "Add Tutor to Client Pool"}
          </button>
        )}
      />
    );
  });

export default ClientRequestModal;
